import React, { useState } from 'react';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import ModalOuterContainer from '../containers/ModalOuterContainer';

const ConfirmModal = ({
    title = '',
    message = 'Are you sure?',
    handleSubmit,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleConfirmClick = async () => {
      try {
        setIsLoading(true);
        await handleSubmit();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    return (
        <ModalOuterContainer handleSubmit={handleConfirmClick} isPosting={isLoading}>
            <div className="description">
                {title !== '' && <Typography tag="h1">{title}</Typography>}
                <Typography>{message}</Typography>
            </div>
        </ModalOuterContainer>
    );
};

export default ConfirmModal;
